import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getGroups = (agentId) =>
  http.get('attendance-group/agent?agent=' + agentId).then(handleResponse);

/**
 * getAttendanceGroupByAgentId
 * Retorna todos os grupos no qual um agente específico faz parte, sem distinção de canal.
 * @param {*} agentId
 * @returns []
 */
export const getAttendanceGroupByAgentId = (agentId) =>
  http.get(`/agents/${agentId}/member/attendance-groups`).then(handleResponse);
